export const meta = {
  title: 'Notifications: what your customers get, and when',
  updatedAt: '2026-07-17',
  related: ['broadcasts', 'queue-board'],
};

Your customers don't stand at the window watching their car — the app pings them. This page lists exactly which notifications exist, what has to be true for them to arrive, and what isn't built yet.

## The automatic pings

Every ticket movement on your queue board fires a push to the customer who booked it:

- **Joins the queue** — _"You're in line."_
- **Wash starts** — _"In the wash."_
- **Ready** — _"Ready for pickup."_ This is the one that brings them back to the counter.
- **Cancelled** — so nobody keeps waiting for a ticket that's gone.
- **On hold** — their spot is paused, not lost.

Two more worth knowing: when a wash tips a customer into a higher loyalty tier, they get a congratulations push on the spot. And one that does **not** exist: there's no push when a ticket is collected and paid — no receipt notification. Points and history are in their app, but nothing pings.

## What has to be true first

Push needs the customer's permission. Their app asks at a sensible moment — right after they book, when a notification obviously helps — never as a cold pop-up on first open. If they decline, nothing breaks: they can still watch their ticket move live inside the app; they just don't get pinged.

## What customers control

In their app's notification settings, each customer chooses:

- **Wash updates** and **marketing** separately, per channel.
- **Quiet hours** — a nightly window (22:00–08:00 by default) during which marketing stays silent.

Wash-status updates are treated as essential and always deliver when push is on. Marketing is strictly opt-in-respecting: opt-outs and quiet hours are enforced on every broadcast you send — see the broadcasts article for how skips are reported to you.

## Honest limits

- **The wording is fixed, and currently English-only.** You can't edit notification text per business yet, and it doesn't follow the customer's app language yet.
- **WhatsApp and SMS don't send anything today.** The toggles exist in customer settings and the platform has the WhatsApp integration slot reserved, but no WhatsApp or SMS message goes out — push is the only live channel. When WhatsApp support ships (using your own business number), this manual gets a setup article for it.
